<template>
    <base-dialog :loading="loading" :value="dialog" :width="420" :title="$t('common.filter_students')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="filter-body">
            <div class="switch-row">
                <span class="switch-label" :class="{ active: !isTeams }">{{ $t('common.groups') }}</span>
                <v-switch v-model="isTeams" hide-details inset dense color="secondary" class="filter-switch ma-0 pa-0" />
                <span class="switch-label" :class="{ active: isTeams }">{{ $t('common.teams') }}</span>
            </div>

            <div v-if="!isTeams" class="chips-wrap">
                <p v-if="groups.length === 0" class="empty-msg">{{ $t('common.no_groups_yet') }}</p>
                <button v-for="g in groups" :key="g.id" type="button" class="filter-chip"
                    :class="{ selected: group && group.id === g.id }" @click="selectGroup(g)">
                    {{ g.name }}
                </button>
            </div>

            <div v-else class="teams-wrap">
                <p v-if="teams.length === 0" class="empty-msg">{{ $t('common.no_teams_yet') }}</p>
                <div v-for="t in teams" :key="t.id" class="team-row">
                    <button type="button" class="team-name" :class="{ selected: team && team.id === t.id && !subgroup }"
                        @click="selectTeam(t)">
                        {{ t.name }}
                    </button>
                    <div class="chips-wrap">
                        <button v-for="(sg, i) in subgroupsOf(t)" :key="i" type="button" class="filter-chip"
                            :class="{ selected: isSubgroupSelected(t, sg) }" @click="selectSubgroup(t, sg)">
                            {{ sg.name }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <template v-slot:footer>
            <v-btn block depressed x-large color="primary" class="footer-btn black--text" @click="filter"
                :loading="loading">
                {{ $t('common.filter') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>

import BaseDialog from "@/components/common/BaseDialog";
export default {
    name: "FilterStudentsDialog",
    components: { BaseDialog },
    props: {
        groups: {
            type: Array,
            default: () => []
        },
        teams: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            isTeams: true,
            team: null,
            subgroup: null,
            group: null,
        }
    },
    computed: {
        payload(vm = this) {
            if (vm.isTeams) return { team: vm.team?.id, subgroupId: vm.subgroup?.id }
            return { group: vm.group?.id }
        }
    },
    methods: {
        subgroupsOf(team) {
            const vm = this
            return (team?.groups || []).map((group, i) => ({
                ...group,
                name: group.name || `${vm.$t('common.subgroup')} ${i + 1}`
            }))
        },
        selectGroup(group) {
            const vm = this
            vm.group = (vm.group && vm.group.id === group.id) ? null : group
        },
        selectTeam(team) {
            const vm = this
            const alreadyTeamOnly = !!vm.team && vm.team.id === team.id && !vm.subgroup
            vm.subgroup = null
            vm.team = alreadyTeamOnly ? null : team
        },
        selectSubgroup(team, subgroup) {
            const vm = this
            if (vm.team && vm.team.id === team.id && vm.subgroup && vm.subgroup.id === subgroup.id) {
                vm.subgroup = null
                return
            }
            vm.team = team
            vm.subgroup = subgroup
        },
        isSubgroupSelected(team, subgroup) {
            const vm = this
            return !!vm.team && vm.team.id === team.id && !!vm.subgroup && vm.subgroup.id === subgroup.id
        },
        show() {
            const vm = this
            vm.dialog = true
        },
        hide(reset = true) {
            const vm = this
            vm.dialog = false
            if (reset) vm.reset()
        },
        reset() {
            const vm = this
            vm.team = null
            vm.subgroup = null
            vm.group = null
        },
        async filter() {
            const vm = this
            vm.loading = true
            vm.$emit('filter', vm.payload)
            vm.loading = false
            vm.hide(false)
        }
    },

}
</script>

<style scoped>
.filter-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.switch-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.switch-label {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtMuted-base);
}

.switch-label.active {
    font-weight: 600;
    color: var(--v-secondary-base);
}

.filter-switch {
    flex: 0 0 auto;
}

.chips-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.empty-msg {
    font-size: 13px;
    color: var(--v-txtMuted-base);
    margin: 4px 0;
}

.filter-chip {
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface2-base);
    color: var(--v-txtSecondary-base);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.12s;
    white-space: nowrap;
}

.filter-chip.selected {
    background: rgba(102, 204, 204, 0.12);
    border-color: var(--v-accent-base);
    color: var(--v-secondary-base);
}

.team-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid var(--v-outline-base);
}

.team-row:last-child {
    border-bottom: none;
}

.team-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    min-width: 130px;
    flex-shrink: 0;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}

.team-name.selected {
    color: var(--v-secondary-base);
    font-weight: 600;
}

.footer-btn {
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>